import { Box, BoxProps, Typography } from '@mui/material';

type HeaderTagProps = { text: string } & Omit<BoxProps, 'children'>;

export const HeaderTag = ({ text, sx, ...props }: HeaderTagProps) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: 0,
        left: '50%',
        translate: '-50% -40%',
        bgcolor: 'primary.main',
        px: 2,
        minWidth: '50%',
        textAlign: 'center',
        borderRadius: 0.25,
        ...sx,
      }}
      {...props}
    >
      <Typography variant={'button'} color={'white'} fontWeight={'bold'} fontSize={'small'} whiteSpace={'nowrap'}>
        {text}
      </Typography>
    </Box>
  );
};
